export const dmarcGenerator = {
    meta: {
        title: "DMARC Record Generator - Protect your Domain",
        ogTitle: "DMARC Record Generator - Protecting Domains",
        description: "Create your DMARC record immediately with DMARCFlow. No registration, no DNS knowledge required. Block spoofing now and protect your domain from phishing."
    },
    "setupBlock": {
        "title": "DMARC ist kompliziert – wir übernehmen das für Sie",
        "subTitle": "Keine Lust auf Technik? Buchen Sie ein einmaliges DMARC-Einrichtungs-Gespräch",
        "benefit1": "Komplette Einrichtung durch einen Experten",
        "benefit2": "Keine laufenden Tools oder Dashboards erforderlich",
        "benefit3": "Einmalige Einrichtung – von Anfang an korrekt konfiguriert",
        "cta": "Setup-Hilfe buchen"
    },
    generator: {
        title: "Erstelle deinen DMARC-Eintrag",
        subTitle: "Erstelle schnell einen DMARC-Eintrag und füge ihn mühelos in deine DNS ein.",
        form: {
            showMore: "Erweiterte Konfiguration",
            domainName: {
                title: "Domainname",
                info: "Der Domänenname, den Sie für DMARC-, SPF- und DKIM-Richtlinien konfigurieren möchten.",
                placeholder: "Domainnamen eingeben"
            },
            version: {
                title: "DMARC-Version",
                info: "Die DMARC Version, die angewendet werden soll. Aktuell gibt es nur die Version 1."
            },
            policy: {
                title: "Richtlinie",
                info: "Gibt an, wie mit E-Mails umgegangen wird, die DKIM/SPF nicht bestehen: none: Zustellung ohne Einschränkung, quarantine: E-Mails werden als Spam behandelt, reject: E-Mails werden blockiert."
            },
            adkim: {
                title: "Adkim",
                info: "Bestimmt die DKIM-Ausrichtung. Mit 'strict' (s) müssen die DKIM-Prüfungen exakt übereinstimmen. Mit 'relaxed' (r) sind leichte Abweichungen, wie Subdomains, erlaubt. Beispiel: adkim=r für relaxed."
            },
            aspf: {
                title: "ASPF",
                info: "Bestimmt die SPF-Ausrichtung. Mit 'strict' (s) müssen SPF-Prüfungen exakt übereinstimmen. Mit 'relaxed' (r) sind leichte Abweichungen, wie Subdomains, erlaubt. Beispiel: aspf=r für relaxed."
            },
            hint: "Bitte beachte, dass aspf und adkim optionale Einstellungen sind. Das Attribut p= gibt an, was Mailserver mit E-Mails tun sollen, die SPF und DKIM nicht bestehen.",
            subdomainPolicy: {
                title: "Subdomain-Richtlinie",
                info: "Definiert, wie E-Mail-Server mit Nachrichten umgehen sollen, die von Subdomains der Hauptdomain gesendet werden. Sie ist eine Erweiterung der Haupt-Policy (p), die speziell für Subdomains gilt. Wenn die sp-Richtlinie nicht gesetzt ist, erben Subdomains automatisch die DMARC-Policy (p) der Hauptdomain. Mit der sp-Richtlinie kann jedoch eine eigenständige Policy nur für Subdomains festgelegt werden."
            },
            percentage: {
                title: "Prozentsatz",
                info: "Gibt den Prozentsatz der E-Mails an, die DMARC-Prüfungen nicht bestehen und für die die Richtlinie (z. B. Quarantäne oder Zurückweisung) gilt. Der Standardwert ist 100. Verwenden Sie niedrigere Werte (z. B. pct=50), um Richtlinien schrittweise zu testen."
            },
            reportInterval: {
                title: "Intervall für Aggregatberichte (in Sekunden)",
                info: "Legt fest, wie oft (in Sekunden) aggregierte DMARC-Berichte an die angegebene rua-Adresse gesendet werden. Der Standardwert ist 86400 (24 Stunden). Passen Sie bei Bedarf eine häufigere Berichterstattung an (z. B. ri=3600 für stündliche Berichte)."
            },
            failureOptions: {
                title: "Fehleroptionen",
                info: "Gibt an, wie forensische (Fehler-)Berichte erstellt werden, wenn eine E-Mail DMARC-Prüfungen nicht besteht. Die Optionen umfassen: 0: Erzeugt Berichte, wenn sowohl SPF als auch DKIM fehlschlagen (Standard), 1: Erzeugt Berichte, wenn entweder SPF oder DKIM fehlschlagen, d: Berichte generieren, wenn DKIM fehlschlägt, s: Berichte generieren, wenn SPF fehlschlägt.",
                both: "Beide",
                spfOrDkim: "SPF oder DKIM"
            },
            reportingFormat: {
                title: "Berichtsformat",
                info: "Gibt das Format der forensischen (Fehler-)Berichte an, die an die E-Mail-Adresse im ruf-Tag gesendet werden. Übliche Werte sind: afrf: Aggregate Feedback Report Format (Standard). iodef: Incident Object Description Exchange Format (verwendet für die Berichterstattung über Sicherheitsvorfälle)."
            },
            spfIncludes: {
                title: "SPF Includes",
                placeholder: "z.B. _spf.google.com",
                info: "Ermöglicht es Ihnen, Mailserver von Drittanbietern zu autorisieren, E-Mails im Namen Ihrer Domain zu versenden. Dies ist nützlich, wenn Sie externe Dienste (z. B. Marketingplattformen, CRMs) zum Senden von E-Mails verwenden."
            },
            dkimSelector: {
                title: "DKIM-Selektor",
                info: "Gibt den Selektor an, der zum Auffinden des öffentlichen DKIM-Schlüssels im DNS verwendet wird. Er identifiziert den spezifischen DKIM-Schlüssel für eine Domäne, so dass mehrere Schlüssel nebeneinander bestehen können.",
                placeholder: "DKIM-Selektor eingeben"
            },
            rua: {
                title: "Aggregatberichte (RUA)",
                info: "Gibt die E-Mail-Adresse(n) an, an die DMARC-Gesamtberichte (zusammenfassende Berichte) gesendet werden. Diese Berichte bieten Einblicke in die Authentifizierungsergebnisse für die E-Mails Ihrer Domäne. Sie können hier mehrere E-Mail-Adressen hinzufügen.",
                placeholder: "RUA-E-Mail eingeben",
                add: "Hinzufügen"
            },
            ruf: {
                title: "Forensische Berichte (RUF)",
                placeholder: "RUF-E-Mail eingeben",
                info: "Gibt die E-Mail-Adresse(n) an, an die DMARC-Forensikberichte (Fehlerberichte) gesendet werden. Diese Berichte enthalten detaillierte Informationen über einzelne E-Mails, die DMARC-Prüfungen nicht bestanden haben. Sie können hier mehrere Adressen hinzufügen",
                add: "Hinzufügen"
            },
            generate: "Erstelle DMARC Record",
            "result": {
                "title": "Dein DMARC-Eintrag",
                "subTitle": "Kopiere diesen Eintrag und füge ihn als TXT-Record in deinen DNS ein.",
                "copy": "Kopieren",
                "emailForm": {
                    "title": "Möchtest du mehr über DMARC erfahren?",
                    "subtitle": "Gib deine E-Mail-Adresse ein und wir senden dir nützliche Informationen und Updates.",
                    "placeholder": "z.B. name@example.com",
                    "cta": "Infos senden",
                    "disclaimer": "Wir senden dir nur hilfreiche Inhalte rund um DMARC. Kein Spam, versprochen.",
                    acceptTerms: "Ich stimme den allgemeinen Geschäftsbedingungen zu"
                }
            },
            error: {
                title: "Fehler bei dem Generieren des DMARC-Datensatzes",
                noDomainGiven: "Bitte geben Sie eine gültige Domain ein"
            }
        }
    },
    whySettingUpIsANightMare: {
        title: "Warum DIY ein Albtraum sein kann",
        subTitle: "Seien wir ehrlich – das Einrichten eines DMARC-Eintrags ist verwirrend, fehleranfällig und frustrierend.",
        list: ["❌ Ein Tippfehler = keine E-Mail-Zustellung", "Sie erhalten rohe XML-Berichte, die für Maschinen gedacht sind", "❌ Unzählige kryptische Tags: <code>p=quarantine</code>, <code>aspf=s</code>, <code>fo=1</code>… was bedeuten die überhaupt?", "❌ Keine Warnungen, keine Transparenz – bis etwas schiefläuft", "❌ DNS-Formatierung ist gnadenlos – und es gibt kein Zurück"],
        underTitle: "Sie wollen es gleich beim ersten Mal richtig machen? - Holen Sie sich Hilfe von einem echten Menschen. Einmalig, kein Abonnement.",
        cta: "DMARC-Einrichtung buchen"
    },
    whatIsADmarcRecord: {
        "explanation": {
            "title": "Beispiel für einen DMARC-Eintrag:",
            "recordExample": "v=DMARC1; p=none; rua=mailto:app@dmarcflow.com",
            "entries": {
                "version": "Version",
                "policy": "Richtlinie (none = keine Maßnahme)",
                "rua": "E-Mail-Adresse, an die Berichte gesendet werden"
            },
            "whyNeeded": "Ohne DMARC-Eintrag funktioniert Ihre Domain zwar – aber Sie haben keine Einsicht, wer sie nutzt, keine Warnungen bei Spoofing und keine Kontrolle über Missbrauch.",
            "benefitsTitle": "Mit einem DMARC-Eintrag erhalten Sie:",
            "benefits": {
                "0": "Mehr E-Mail-Sicherheit",
                "1": "Einblick in unautorisierte Aktivitäten",
                "2": "Mehr Vertrauen bei Mailservern und Empfängern"
            }
        }
    },
    howToCreateADMarcRecord: {
        title: "Wie erstelle ich einen DMARC-Eintrag?",
        description: "Mit dem DMARC Record Generator von DMARCFlow ist der Prozess schnell und einfach: 1. Gib deine Domain ein und wähle die gewünschte Richtlinie aus (mehr zu Richtlinien hier). Gib die E-Mail-Adressen für DMARC-Berichte (Aggregat und Fehler) ein. Klicke auf „Generieren“, um deinen Eintrag zu erstellen. Für fortgeschrittene Einstellungen sind weitere Optionen verfügbar, diese kannst du jedoch überspringen und trotzdem einen voll funktionsfähigen Eintrag erhalten."
    },
    pricing: {
        cta: "Einrichtung buchen"
    },
    faq: {
        title: "Frequently Asked Questions",
        subTitle: "Sie haben Fragen? Wir haben Antworten!",
        list: [
            {
                question: "Was ist ein DMARC Record Generator?",
                answer: "Der DMARC Record Generator von DMARCFlow ermöglicht es dir, in wenigen Klicks einen gültigen DMARC-Eintrag zu erstellen. Die generierte Syntax erfüllt alle Anforderungen und ist direkt bereit zur Veröffentlichung in deiner DNS."
            },
            {
                question: "Wie implementiert man einen DMARC-Eintrag für die eigene Domain?",
                answer: "Sobald der Eintrag generiert wurde, kopiere ihn und gehe zur DNS-Zone deiner Domain. Füge einen neuen TXT- oder CNAME-Eintrag hinzu und füge den bereitgestellten DMARC-Eintrag ein. Hinweis: Die meisten DNS-Anbieter (z. B. GoDaddy) fügen den Domainnamen im Feld Host/Name automatisch hinzu, daher genügt die Eingabe von _dmarc."
            },
            {
                question: "Wie sieht das DMARC-Format aus?",
                answer: "TXT ist das anerkannte Format für DMARC-Einträge, wenn du sie manuell verwaltest. Bei Verwendung der Managed-DMARC-Lösung von DMARCFlow muss ein CNAME-Eintrag zur DNS hinzugefügt werden. Ein CNAME (Canonical Name) ist ein DNS-Eintrag, der eine Alias-Verknüpfung zur Domain herstellt und den Datenverkehr an eine andere Adresse weiterleiten kann."
            },
            {
                question: "Was ist DMARC-Domain-Alignment?",
                answer: "Domain-Alignment ist ein zentrales Konzept von DMARC. Eine Übereinstimmung liegt vor, wenn der Domainname im 'From'-Header der E-Mail mit der Domain des Absenders übereinstimmt. Dadurch besteht die DMARC-Prüfung und zeigt an, dass es sich um eine legitime E-Mail handelt. DMARC-Domain-Alignment schützt vor Spoofing, Identitätsdiebstahl, Business E-Mail Compromise und Phishing."
            },
            {
                question: "Wie funktioniert DMARC mit Subdomains?",
                answer: "Subdomains übernehmen standardmäßig die DMARC-Richtlinien der übergeordneten Domain, sofern keine eigene Richtlinie definiert ist. Wenn z. B. die Hauptdomain eine 'reject'-Richtlinie verwendet, wird diese auch auf die Subdomain angewendet. Bei separater Konfiguration wird die manuelle Einstellung jedoch nicht überschrieben."
            },
            {
                question: "Kann ich einen DMARC-Eintrag ohne SPF oder DKIM hinzufügen?",
                answer: "Du kannst den Eintrag hinzufügen, aber er wird nicht richtig funktionieren. DMARC basiert auf SPF und DKIM. Um die Prüfung zu bestehen, muss die E-Mail entweder SPF oder DKIM (bzw. beide) bestehen, einschließlich Alignment. Wenn beides fehlt, schlägt DMARC fehl."
            }
        ]
    }
};